// icon:flower | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

export default function Birth(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
        <path
              d="M480 170.3C480 94.03 417.1 32 341.7 32C310.5 32 280.3 42.84 256 62.31C231.7 42.84 201.5 32 170.3 32C94.03 32 32 94.03 32 170.3C32 201.5 42.83 231.7 62.3 256C42.83 280.3 32 310.5 32 341.7C32 417.1 94.03 480 170.3 480C201.5 480 231.7 469.2 256 449.7C280.3 469.2 310.5 480 341.7 480C417.1 480 480 417.1 480 341.7C480 310.5 469.2 280.3 449.7 256C469.2 231.7 480 201.5 480 170.3zM400.8 274.1C420.9 291.7 432 315.7 432 341.7C432 391.5 391.5 432 341.7 432c-26.03 0-50.06-11.09-67.66-31.22L256 380.1l-18.06 20.66C220.3 420.9 196.3 432 170.3 432C120.5 432 80 391.5 80 341.7c0-26.03 11.08-50.06 31.19-67.66L131.9 256L111.2 237.9C91.08 220.3 80 196.3 80 170.3C80 120.5 120.5 80 170.3 80c26.03 0 50.06 11.09 67.66 31.22L256 131.9l18.06-20.66C291.7 91.09 315.7 80 341.7 80C391.5 80 432 120.5 432 170.3c0 26.03-11.08 50.06-31.19 67.66L380.1 256L400.8 274.1zM256 176C211.9 176 176 211.9 176 256s35.88 80 80 80s80-35.88 80-80S300.1 176 256 176zM256 288C238.4 288 224 273.6 224 256s14.36-32 32-32s32 14.36 32 32S273.6 288 256 288z"/>
    </svg>
  );
}
